import IntegrationSecurity from "@/components/IntegrationSecurity";

export default function Integration() {
  return (
    <div>
      <main>
        <IntegrationSecurity />
      </main>
    </div>
  );
}